<template>
  <sui-modal class="wrapper" v-model="visible" size="small" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Create account
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <sui-form-field>
          <FormAccount v-model="entity" mode="creating" />
        </sui-form-field>
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_ACCOUNT_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ModalForm from '@/mixins/ModalForm'
  import FormAccount from '@/components/forms/Account'
  import utils from '@/utils'

  export default {
    name: 'ModalCreateAccount',
    mixins: [
      ModalForm,
    ],
    components: {
      FormAccount,
    },
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      open(entity = {}) {
        this.visible = true
        this.entity = {
          ...entity,
          email: this.user.email,
          name: entity.name || utils.generateName(),
        }
      },
      onSuccess(data) {
        // TODO: this is fallback: add member data which absent in socket event "create"
        this.$store.commit('updateEntity', {...data, target: 'account'})
        this.close()
        utils.reachGoal('CREATE_ACCOUNT_SUCCESS')
      },
      onFail() {
        utils.reachGoal('CREATE_ACCOUNT_FAIL')
      },
    },
    created() {
      this.$modals.createAccount = this
    },
  }
</script>
